export default __webpack_public_path__ + "static/media/profile.dd74fee6.jpg";